import React, { useState, useEffect } from 'react';

import Filters from '../components/Filters';
import GlobalWrapper from '../../../../../components/Wrapper/GlobalWrapper';
import GlobalDatagrid from '../../../../../components/mui/DataGrid/GlobalDatagrid';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getPendingReports } from '../../../../../redux/features/crmSlice';
import ToolTip from '../../../../../components/ToolTip/ToolTip';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

export default function PendingPreAssessments({
  title = 'Pending pre assesments',
  type = 'pre',
  impactReport,
  impactDownloadedView = false,
}) {
  const {
    paginationData: { gridSize, pageNum, search },
  } = useSelector((state) => state.globalDataGrid);

  const { pendingReports, meta, pendingReportLoading } = useSelector((state) => state.crm);

  const [allFilter, setAllFilter] = useState({
    subject_id: '',
    course_id: '',
    cro_id: '',
  });

  const tableHead = [
    { field: 'sl_no', headerName: 'Sl.No', width: 100 },
    { field: 'trainer_name', headerName: 'Tutor Name', width: 300 },
    { field: 'student_name', headerName: 'Student Name', width: 300 },
    { field: 'cro_name', headerName: 'CRO Name', width: 300 },
    { field: 'admn_no', headerName: 'Admission Number', width: 180 },
    {
      field: 'course_name',
      headerName: 'Course',
      width: 200,
      renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
    },
    { field: 'subject_name', headerName: 'Subject', width: 180 },
    { field: 'completed_sessions', headerName: 'Completed Sessions', width: 150, type: 'number' },
    { field: 'total_sessions', headerName: 'Total Sessions', width: 120, type: 'number' },
    ...(impactReport
      ? [
          {
            field: 'impactReport',
            headerName: 'Impact Report',
            width: 160,
            renderCell: ({ value, row }) => (
              <Link to={`/dashboard/impact-report/${row?.course_enrollment_id}`}>
                <Button startIcon={<RemoveRedEyeIcon />}>View</Button>
              </Link>
            ),
          },
        ]
      : []),
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getPendingReports({
        path: type,
        page: pageNum,
        limit: gridSize,
        search,
        subject_id: allFilter.subject_id,
        course_id: allFilter.course_id,
        cro_id: allFilter.cro_id,
        ...(type === 'download' && { is_downloaded: Number(impactDownloadedView) }),
      }),
    );
  }, [gridSize, pageNum, search, allFilter, impactDownloadedView, type, dispatch]);

  return (
    <GlobalWrapper title={title}>
      <Filters allFilter={allFilter} setAllFilter={setAllFilter} />
      <GlobalDatagrid
        tableHead={tableHead}
        meta={meta?.totalRecords}
        rows={pendingReports}
        rowUniqueId={'sl_no'}
        loading={pendingReportLoading}
      />
    </GlobalWrapper>
  );
}
